<template>
	<div class="filterBlock">
		<div class="filterBlock_btn">
			<custom-btn
					text="Create payment"
					custom-class="apply"
					@updateEvent="onCreatePayments"
					:is-disabled="isCreate"
			></custom-btn>
		</div>
		<div class="filterBlock_label">Filter</div>
		<field
				margin="0 0 10px 0"
				label="Customer"
				placeholder="Select customer"
				@updateMultiSelect="onSelect($event, 'filter_customer')"
				:multiValue="filters['filter_customer']"
				:items="customerFilter"
				:isClearable="false"
				is-multiple
				:is-return-object="false"
				is-attach
		></field>
		<field
				margin="0 0 10px 0"
				label="Truck #"
				placeholder="Select truck"
				@updateMultiSelect="onSelect($event, 'filter_truck')"
				:multiValue="filters['filter_truck']"
				:items="truckFilter"
				:isClearable="false"
				is-multiple
				:is-return-object="false"
				is-attach
		></field>
		<field
				margin="0 0 10px 0"
				label="Driver"
				placeholder="Select Driver"
				@updateMultiSelect="onSelect($event, 'filter_driver')"
				:multiValue="filters['filter_driver']"
				:items="driverFilter"
				:isClearable="false"
				is-multiple
				:is-return-object="false"
				is-attach
		></field>
		<field
				margin="0 0 10px 0"
				label="Payment"
				placeholder="Select payment"
				@updateMultiSelect="onSelect($event, 'filter_payment_type')"
				:multiValue="filters['filter_payment_type']"
				:items="paymentFilter"
				:isClearable="false"
				is-multiple
				:is-return-object="false"
				is-attach
		></field>
		<row isRight>
			<button
					class="mainBtn mainBtn-text not-hover iconHoverRotate"
					@click="onReset"
			>
				<span class="btnIco"><svg-sprite icon-id="refresh" width="20" height="20"></svg-sprite></span>
				<span class="btnText">Refresh filters</span>
			</button>
		</row>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "FilterBlock",
	props: {
		filterCalendarPayments: Object,
		filters: Object,
		isCreate: Boolean,
	},
	watch: {
		filterCalendarPayments(val, oldVal) {
			if (val !== oldVal) {
				const { filter_customer, filter_driver, filter_truck, filter_payment_type } = this.filterCalendarPayments;
				this.customerFilter = filter_customer;
				this.driverFilter = filter_driver;
				this.truckFilter = filter_truck;
				this.paymentFilter = filter_payment_type;
			}
		}
	},
	data: () => ({
		customerFilter: [],
		truckFilter: [],
		driverFilter: [],
		paymentFilter: [],
	}),
	methods: {
		...mapActions([ 'getCalendarOnDate' ]),
		onSelect({ value }, key) {
			this.$emit('updateFilterField', { value, key });
		},
		onCreatePayments() {
			this.$emit('updateCreatePayments');
		},
		async onReset() {
			this.$emit('updateFilterReset');
		}
	},
	mounted() {
		const { filter_customer, filter_driver, filter_truck, filter_payment_type } = this.filterCalendarPayments;
		this.customerFilter = filter_customer;
		this.driverFilter = filter_driver;
		this.truckFilter = filter_truck;
		this.paymentFilter = filter_payment_type;
	}
};
</script>

<style scoped lang="scss">
@import "FilterBlock";
</style>
